var uiModule = require("./selectedsprite/ui.js");
var compileModule = require("./selectedsprite/compile.js");
var workspaceModule = require("./selectedsprite/workspace.js");

var EditorData = require("./sprite-editordata.js");
var engine = require("./curengine.js");
var blocks = require("./blocks.js");
var costumeViewer = require("./costumeviewer.js");
var soundViewer = require("./soundviewer.js");
var compiler = require("../compilerv2");
var blockMenu = require("./blockmenuloader.js");
var isProjectDirty = false;
var { valueReport } = require("./value-report.js");
var { makeSortable } = require("./drag-utils.js");
var { loadBlockMenus } = blockMenu;

// shared mutable state object passed to submodules
var state = {
  currentSelectedSprite: null,
  currentSelectedSpriteIndex: null,
};

var deps = {
  engine,
  blocks,
  costumeViewer,
  soundViewer,
  compiler,
  blockMenu,
  compilerInstance: compiler.newInstance({
    useExportCompile: false,
    useBlockNumberIDs: false,
    engine
  }),
  EditorData,
  valueReport,
  makeSortable,
  loadBlockMenus,
  // these will be filled after init
  ui: null,
  compile: null,
  workspace: null,
  onSetCurrentSprite: null,
};

var ui = uiModule.init(state, deps);
var compile = compileModule.init(state, deps);
// provide compile and ui references into deps for cross-use
deps.compile = compile;
deps.ui = ui;
var workspace = workspaceModule.init(state, deps);
deps.workspace = workspace;

// expose a setCurrentSprite function that coordinates state + ui + workspace
function setCurrentSprite(index, forced, dontSave) {
  if (!forced) {
    if (state.currentSelectedSpriteIndex == index) return;
  }
  if (state.currentSelectedSprite) {
    state.currentSelectedSprite.onErrorLog = function () {};
    state.currentSelectedSprite.threadStartListener = null;
    state.currentSelectedSprite.threadEndListener = null;
    if (workspace) {
      workspace.saveScroll();
      if (!dontSave) {
        EditorData.saveSpriteEditorData(state.currentSelectedSprite, blocks.getCurrentWorkspace());
      }
    }
  }
  state.currentSelectedSpriteIndex = index;
  state.currentSelectedSprite = engine.sprites[index];

  // update inputs/UI
  deps.ui.updateSpritesContainer();
  workspace.loadCode(state.currentSelectedSprite);
  workspace.handleSpriteErrorLog(state.currentSelectedSprite);
  // reload assets
  costumeViewer.reloadCostumes(state.currentSelectedSprite, loadCostumes);
  soundViewer.reloadSounds(state.currentSelectedSprite, loadSounds);
}

var GUIEvents = require("./event.js");

GUIEvents.on(GUIEvents.REFRESH_SPRITE_COSTUMES, () => {
  loadCostumes();
});

GUIEvents.on(GUIEvents.REFRESH_SPRITE_SOUNDS, () => {
  loadSounds();
});

GUIEvents.on(GUIEvents.MARK_PROJECT_DIRTY, () => {
  deps.markProjectDirty();
});

function loadCostumes() {
  costumeViewer.reloadCostumes(state.currentSelectedSprite, loadCostumes);
}
function loadSounds() {
  soundViewer.reloadSounds(state.currentSelectedSprite, loadSounds);
}

function getCurSprite() {
  return state.currentSelectedSprite;
}
function getCurSpriteIndex() {
  return state.currentSelectedSpriteIndex;
}

function saveCurrentSpriteCode() {
  if (state.currentSelectedSprite) {
    workspace.saveCurrentSpriteCode();
  }
}

// wire callback for UI actions (add/select/delete/duplicate)
deps.onSetCurrentSprite = function (idx, forced, dontSave) {
  return setCurrentSprite(idx, forced, dontSave);
};

// expose compile helpers onto blockMenu as before
if (blockMenu && blockMenu.helpers) {
  blockMenu.helpers.loadWorkspaceFromSprite = compile.loadWorkspaceFromSprite;
}

deps.markProjectDirty = function () {
  if (isProjectDirty) {
    return;
  }
  isProjectDirty = true;
};
deps.unmarkProjectDirty = function () {
  if (!isProjectDirty) {
    return;
  }
  isProjectDirty = false;
};
deps.isProjectDirty = function () {
  return isProjectDirty;
};

costumeViewer.deps.markAsDirty = deps.markProjectDirty;
soundViewer.deps.markAsDirty = deps.markProjectDirty;
costumeViewer.deps.forwardMarkAsDirty(); //So that the costume pivot editor could also mark the project as dirty when a pivot is changed.

module.exports = {
  setCurrentSprite,
  updateSpritesContainer: ui.updateSpritesContainer,
  getCurSprite,
  getCurSpriteIndex,
  loadCode: workspace.loadCode,
  compileSpriteXML: compile.compileSpriteXML,
  compileSpriteXMLToString: compile.compileSpriteXMLToString,
  compileAllSprites: compile.compileAllSprites,
  saveCurrentSpriteCode,
  saveScroll: workspace.saveScroll,
  scrollToPrevious: workspace.scrollToPrevious,
  markProjectDirty: deps.markProjectDirty,
  unmarkProjectDirty: deps.unmarkProjectDirty,
  isProjectDirty: deps.isProjectDirty,
  deps: deps,
};
